module.exports = __webpack_public_path__ + "static/img/upgrade-level.c7f103df.png";